import React from "react";
import { KeyResources as KeyResourcesComponent } from "components/molecules/KeyResources";
import { types, Text } from "react-bricks/frontend";
import { useBricksPreloadedProps } from "hooks/useBrickStaticProps";
import { KeyResourcesItemProps } from "components/atoms/KeyResourcesItem";
import styled from "styled-components";
import {
  getVerticalPadding,
  VerticalPadding,
  VerticalPaddingWrapper,
  verticalPadSideProp,
} from "../utils/verticalPadding";
import TextHeading from "../common/TextHeading";

interface KeyResourcesProps {
  title: types.TextValue;
  type: "blog" | "news-and-events" | "case-studies";
  paddingVertical: VerticalPadding;
}

const KeyResources: types.Brick<KeyResourcesProps> = ({ title, type, paddingVertical }) => {
  const { strapiProps } = useBricksPreloadedProps();
  const posts = strapiProps?.[getStrapiKeyFromType(type)]?.posts || [];

  return (
    <VerticalPaddingWrapper paddingVertical={paddingVertical}>
      <Container>
        <TextHeading propName="title" placeholder="Enter Title" padBottom={true} value={title} />

        <KeyResourcesComponent
          title={""}
          resourcesInfo={posts as KeyResourcesItemProps[]}
          urlPrefix={type}
        />
      </Container>
    </VerticalPaddingWrapper>
  );
};

const getStrapiKeyFromType = (type: KeyResourcesProps["type"]) => {
  switch (type) {
    case "blog":
      return "getBlogPosts" as const;
    case "case-studies":
      return "getCaseStudies" as const;
    case "news-and-events":
      return "getNewsAndEvents" as const;
  }
};

KeyResources.schema = {
  // Unique brick name
  name: "keyresources",
  label: "Key Resources",

  // Defaults when a new brick is added
  getDefaultProps: () => ({
    title: "Key Resources",
    type: "blog",
    paddingVertical: "s",
  }),

  previewImageUrl: `/static/bricks/key-resources.png`,

  // Sidebar Edit controls for props
  sideEditProps: [
    verticalPadSideProp,
    {
      name: "type",
      label: "Type",
      type: types.SideEditPropType.Select,
      selectOptions: {
        display: types.OptionsDisplay.Select,
        options: [
          { value: "blog", label: "Blog posts" },
          { value: "case-studies", label: "Case Studies" },
          { value: "news-and-events", label: "News & Events" },
        ],
      },
    },
  ],
};

export default KeyResources;

const Container = styled.div``;
